"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AdminNotice =
/*#__PURE__*/
function (_Component) {
  _inherits(AdminNotice, _Component);

  function AdminNotice(props) {
    var _this;

    _classCallCheck(this, AdminNotice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdminNotice).call(this, props));
    _this.state = {
      opacity: 1
    };
    return _this;
  }

  _createClass(AdminNotice, [{
    key: "decreaseOpacity",
    value: function decreaseOpacity() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          opacity: _this2.state.opacity - 0.1
        });

        if (_this2.state.opacity > 0) {
          _this2.decreaseOpacity();
        }
      }, 50);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      if (this.props.disappear) {
        setTimeout(function () {
          _this3.decreaseOpacity();
        }, 3000);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var noticeClass = '';

      switch (this.props.type) {
        case 'error':
          noticeClass = 'notice notice-error inline';
          break;

        case 'warning':
          noticeClass = 'notice notice-warning inline';
          break;

        case 'info':
          noticeClass = 'notice notice-info inline';
          break;

        default:
          noticeClass = 'notice notice-success inline';
          break;
      }

      if (this.props.dismissible) {
        noticeClass += ' is-dismissible';
      }

      var style = {
        opacity: this.state.opacity,
        display: this.state.opacity > 0 ? 'block' : 'none'
      };
      return _react.default.createElement("div", {
        className: noticeClass,
        style: style
      }, _react.default.createElement("p", null, this.props.message));
    }
  }]);

  return AdminNotice;
}(_react.Component);

var _default = AdminNotice;
exports.default = _default;